import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="max-w-sm w-full text-center animate-fade-up" data-testid="payment-cancel-page">
        <XCircle className="h-12 w-12 text-muted-foreground mx-auto" />
        <h1 className="text-2xl font-bold font-display mt-4">{t("billing.cancelTitle")}</h1>
        <p className="text-muted-foreground mt-2">{t("billing.cancelDesc")}</p>
        <div className="mt-6 space-y-2">
          <Button className="w-full brand-bg text-white" onClick={() => navigate("/pricing")} data-testid="payment-cancel-retry">
            {t("billing.tryAgain")}
          </Button>
          <Button variant="outline" className="w-full" onClick={() => navigate("/dashboard")} data-testid="payment-cancel-dashboard">
            {t("billing.backToDashboard")}
          </Button>
        </div>
      </div>
    </div>
  );
}
